import Api from './baseApi';

export default {
  getAll: () => Api.get('/api/deliveryCities'),
  get: (id) => Api.get(`/api/deliveryCities/${id}`),
  post: (city) => Api.post('/api/deliveryCities', city),
  put: (city) => Api.put(`/api/deliveryCities/${city.id}`, city),
  delete: (id) => Api.delete(`/api/deliveryCities/${id}`),
};
